import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import $ from 'jquery';

const DEFAULT_FILE_NAME = 'swisscom.pdf';

function getFileNameFromDisposition(disposition : string | null) : string {
	let fileName = DEFAULT_FILE_NAME;
	if (disposition && disposition.indexOf('attachment') !== -1) {
		const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = fileNameRegex.exec(disposition);
		if (matches !== null && matches[1]) {
			fileName = matches[1].replace(/['"]/g, '');
		}
	}

	return fileName;
}


function createPostRequest(url : string, data : string) : Promise<XMLHttpRequest> {
	return new Promise((resolve, reject) => {
		const request = new XMLHttpRequest();
		request.open('POST', url, true);
		request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		request.onreadystatechange = () => {
			/*
			 This part is neccessary to solve the error:
			 Uncaught InvalidStateError: Failed to read the 'responseText' property
			 from 'XMLHttpRequest': The value is only accessible if the object's
			 'responseType' is '' or 'text' (was 'blob').
			 This is the actual reasone to use XMLHttpRequest instead of $.ajax()
			 */
			if(request.readyState === 2) {
				if(request.status === 200) {
					request.responseType = 'blob';
				} else {
					request.responseType = 'text';
				}
			}
		};
		request.onload = () => resolve(request);
		request.onerror = () => reject(request);

		request.send(data);
	});
}

/**
 * Download pdf button for transfering number. It is used to submit the wizard
 * form to appropriate servlet which will response with a populated pdf file.
 *
 * @author Igor Velickovic
 * @class DownloadNRepPDF
 * @extends Tc.Module
 */
export default class DownloadNRepPDF extends Module {

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {

		this.$ctx.find('.download-button').on('click', (e : JQuery.ClickEvent) => {
			e.preventDefault();
			e.stopPropagation();

			const $form = this.$ctx.closest('form.wizard');

			const dataString = $('input[name!=":formid"],[name!=":formstart"],[name!=":formtype"]', $form)
				.find('input, textarea, select')
				.serialize();

			const ajaxUrl = $(e.target).data('url') as string;

			createPostRequest(ajaxUrl, dataString)
			.then((request : XMLHttpRequest) => {
				const disposition = request.getResponseHeader('content-disposition');
				const fileName = getFileNameFromDisposition(disposition);

				if (window.navigator && window.navigator.msSaveOrOpenBlob) { // For IE
					window.navigator.msSaveOrOpenBlob(request.response, fileName);
				} else { // For Non-IE (chrome, firefox etc.)
					const a = document.createElement('a');
					const url = URL.createObjectURL(request.response);
					a.href = url;
					a.download = fileName;
					document.body.appendChild(a);
					a.click();
					a.remove();
				}
			})
			.catch((err : any) => this.log(err));
		});

		callback();
	}

}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/newrepair/Tc.Module.DownloadNRepPDF.ts